import React from 'react';
import { useSelector } from 'react-redux';

import { Avatar, Radio, Typography } from 'antd';
import { getRandomColorsBassedOnLetters } from '../../../../../../helper/colors';
const { Text } = Typography;

const TeamMemberList = ({
  avatarSize = 'large',
  selectedMember = '',
  handleMemberSelect = () => {},
}) => {
  // selectors
  const { currentUser, isSocketConnected } = useSelector((state) => state?.app);
  const { teamMembers, activeUsers } = useSelector((state) => state?.inbox);

  // states

  return (
    <div className="flex flex-col gap-2">
      {teamMembers?.map((member) => {
        const { color, backgroundColor } = getRandomColorsBassedOnLetters(
          member.first_name + ' ' + (member.last_name || ''),
        );
        const isOnline =
          activeUsers?.find((user) => user?.user_id == member?.user_id)
            ?.status === 'connected';
        const isMe = member?.user_id == currentUser?.id;
        const AmIOnline = isMe && isSocketConnected;

        return (
          <div
            key={member.team_member_id}
            className="flex items-center gap-2 p-1 cursor-pointer bg-slate-100 rounded-lg px-4 py-2 hover:bg-slate-200"
            onClick={() => handleMemberSelect(member.team_member_id)}
          >
            <Radio
              value={member.team_member_id}
              checked={selectedMember == member.team_member_id}
              // onChange={(e) => setSelectedMember(e.target.value)}
            />
            {member?.profile_photo ? (
              <Avatar src={member.profile_photo} size={avatarSize}></Avatar>
            ) : (
              <Avatar
                style={{
                  backgroundColor: backgroundColor,
                  verticalAlign: 'middle',
                  color: color,
                }}
                size={avatarSize}
              >
                {member.first_name?.[0]?.toUpperCase()}
                {member.last_name?.[0]?.toUpperCase()}
              </Avatar>
            )}

            <div className="flex flex-col">
              <Text strong className="text-sm">
                {isMe
                  ? 'Me'
                  : member.screen_name ||
                    `${member.first_name} ${member.last_name || ''}`.trim()}
              </Text>
              <Text type="secondary" className="text-xs">
                {member?.email}
              </Text>
            </div>
            <div
              className={`w-2 h-2 rounded-full ml-auto ${
                isOnline || AmIOnline ? 'bg-green-500' : 'bg-gray-400'
              }`}
            />
          </div>
        );
      })}
    </div>
  );
};

export default TeamMemberList;
